export default {
  "___documents_page-title": "My Documents",
  "documents_page-description": "Files you have attached to a transaction.",
  "documents_page-placeholder-intro": "Hi, we're working to improve your experience.",
  "documents_page-placeholder-body": "Right now we're working on the new 'My Documents'. You'll be able to upload receipts and match them to expenses is two easy steps. In the mean time, if you need to upload receipts and need to get reimbursed for an item go to get reimbursed.",
  "documents_text_no-documents_step-1": "1. Upload files for your records",
  "documents_text_no-documents_step-2": "2. Adding details will help match it to a transaction for reimbursement",
  "documents_action_get-started": "Get Started",
  "documents_text_upload-guidelines": "Under 10 MB, JPEG, GIF, PDF, TIFF, PNG or BMP",
  "documents_action_upload": "Upload",
  "documents_filter-label_date-range": "Date Range",
  "documents_filter-label_category": "Category",
  "documents_label_all-dates": "All Dates",
  "documents_label_last-30-days": "Last 30 Days",
  "documents_label_last-60-days": "Last 60 Days",
  "documents_label_last-90-days": "Last 90 Days",
  "documents_label_all-categories": "All Categories",
  "documents_label_medical": "Medical",
  "documents_label_drug": "Drug",
  "documents_label_dental": "Dental",
  "documents_label_day-care": "Day Care",
  "documents_label_premium": "Premium",
  "documents_label_transportation": "Transportation",
  "documents_label_other": "Other",
  "documents_label_non-claim-document": "Non-Claim Document",
  "documents_text_no-documents-found": "No documents found.",

  // DOCUMENT CARD
  "document-card_action_see-details": "See Details",
  "document-card_action_see-options": "Options",
  "___document-card_action_get-reimbursed": "",
  "document-card_action_pay-a-provider": "Pay a Provider",
  "___document-card_action_match-to-transaction": "",
  "___document-card_action_edit": "",
  "___document-card_action_delete": "",
  "document-card_text_file-unavailable": "File Unavailable",

  // MY DOCUMENTS MODAL
  "documents_modal_page-title": "Select Documents",
  "___documents_modal_form-label_search": "",
  "documents_modal_form-label_categories": "Categories",
  "___documents_modal_label_medical": "",
  "___documents_modal_label_dental": "",

  // SUBMITTED DOCUMENTS
  "___submitted-documents_page-title": "",
  "submitted-documents_form-label_category": "Category",
  "submitted-documents_form-label_date-status": "Date or Status",
  "___submitted-documents_form-label_search": "",
  "submitted-documents_action_download-files": "Download Files",
  "submitted-documents_action_export-to-xls": "XLS",

  // UNSUBMITTED DOCUMENTS
  "___unsubmitted-documents_page-title": "",

  // ATTACH DOCUMENTS
  "___attach-documents_confirm-close_title": "",
  "___attach-documents_confirm-text_title": "",
  "___attach-documents_yes": "",
  "___attach-documents_no": "",
  "___attach-documents_page-title": "",
  "___attach-documents_title_attachments": "",
  "___attach-documents_title_attachment": "",
  "attach-documents_text_success-message": "Your file was successfully attached.",
  "attach-documents_text_error-message_incorrect-file-type": "The file %filename% is not a supported file type.",
  "attach-documents_text_error-message_file-too-large": "The file %filename% is too large.",
  "attach-documents_error-message-encrypted_PDF": "The PDF you uploaded is password protected and could not be read. Please upload a PDF which is not password protected.",
  "attach-documents_error-message-bad_file": "The file you uploaded could not be read. Please try again.",
  "attach-documents_error-message": "The file you uploaded could not be saved. Please try again.",
  "attach-documents_action_choose-stored-document": "From My Records and Receipts",
  "attach-documents_action_upload-from-files": "From Computer",
  "attach-documents_action_upload-singular-file": "Upload Attachment",
  "attach-documents_message_no-selected-files": "No attachments selected",
  "___attach-documents_text_loading-message": "",
  "attach-documents_form-label_print-claim": "I wish to print and mail this reimbursement.",
  "attach-documents_title_confirm-remove-file": "Are you sure you want to remove this file?",
  "___attach-documents_action_confirm-remove-file_cancel": "",
  "___attach-documents_action_confirm-remove-file_confirm": "",
  "___attach-documents_action_done": "",
  "attach-documents_action_upload": "Upload and Attach Documents",
  "attach-documents_text_refresh-data-error-message": "Your file(s) have been uploaded but we were unable to refresh the data on the screen. Please refresh the page.",
  "attach-documents_text_file-add-error-message": "We are unable to attach your documents at this time.",
  "attach-documents_text_substantiation-error-message": "Unable to process the information at this time. Please try again.",

  // DOCUMENT DETAIL
  "___document-detail_title_confirm-close": "",
  "___document-detail_text_confirm-close": "",
  "___document-detail_action_confirm-close_cancel": "",
  "___document-detail_action_confirm-close_confirm": "",
  "document-detail_action_attach-to-transaction": "Attach to a Transaction",
  "document-detail_action_download-file": "Download File",
  "___document-detail_action_continue": "",
  "document-detail_title_choose-transaction": "Choose a Transaction",
  "document-detail_text_choose-transaction": "Please choose which transaction you'd like to match with this file.",
  "___document-detail_form-label_account": "",
  "___document-detail_action_done": "",

  // DOCUMETN DETAIL FORM
  "document-detail-form_form-label_nickname": "File nickname",
  "document-detail-form_form-label_category": "Category",
  "document-detail-form_form-label_amount": "Amount",
  "document-detail-form_form-label_note-to-self": "Note to Self",
  "document-detail-form_form-error_nickname_length": "File nickname cannot be longer than %maxLength% characters.",
  "___document-detail-form_form-error_category_required": "",
  "___document-detail-form_form-error_amount_required": "",
  "document-detail-form_form-error_amount_max-value": "Amount must be less than $9,999,999,999.99.",
  "document-detail-form_form-error_note-to-self_length": "Note to self cannot be longer than %maxLength% characters.",
  "___document-detail-form_text_refresh-data-error-message": "",

  // UPDATE DOCUMENT DETAIL
  "___update-document-detail_title_confirm-close": "",
  "___update-document-detail_text_confirm-close": "",
  "___update-document-detail_action_confirm-close_cancel": "",
  "___update-document-detail_action_confirm-close_confirm": "",
  "update-document-detail_page-title": "Enter details for",
  "update-document-detail_action_submit": "Submit",
  "___update-document-detail_action_done": "",
  "___update-document-detail_text_loading-message": "",

  // UPLOAD DOCUMENT
  "upload-document_attach-document_page-title": "Upload Document",
  "upload-document_enter-details_page-title": "Add details for",
  "___upload-document_title_confirm-close": "",
  "___upload-document_text_confirm-close": "",
  "___upload-document_action_confirm-close_cancel": "",
  "___upload-document_action_confirm-close_confirm": "",
  "upload-document_step_attach-document": "Attach Document",
  "upload-document_step_enter-details": "Enter Details",
  "___upload-document_action_continue": "",

  // REMOVE DOCUMENT
  "___remove-document_title_confirm-close": "",
  "___remove-document_text_confirm-close": "",
  "___remove-document_action_confirm-close_cancel": "",
  "___remove-document_action_confirm-close_confirm": "",
  "remove-document_page-title": "Are you sure you want to remove this record from the claims vault?",
  "remove-document_page-description": "If you remove this record from the vault, you will not be able view this document in the future.",
  "___remove-document_action_cancel": "",
  "___remove-document_action_confirm": "",
  "___remove-document_action_done": "",
  "remove-document_text_loading-message": "Removing Document…",
  "remove-document_text_refresh-data-error-message": "Your document has been deleted but we were unable to refresh the data on the screen. Please refresh the page.",

  // MATCH TO TRANSACTION
  "___match-to-transaction_title_confirm-close": "",
  "___match-to-transaction_text_confirm-close": "",
  "___match-to-transaction_action_confirm-close_cancel": "",
  "___match-to-transaction_action_confirm-close_confirm": "",
  "___match-to-transaction_action_done": "",
  "match-to-transaction_page-title": "Match to Transaction",
  "match-to-transaction_title_choose-transaction": "Choose a Transaction",
  "match-to-transaction_text_choose-transaction": "Please choose which transaction you'd like to attach this file to.",
  "match-to-transaction_label_amount": "Amount",
  "match-to-transaction_label_category": "Category",
  "match-to-transaction_label_upload-date": "Upload Date",
  "match-to-transaction_label_note": "Note",
  "match-to-transaction_action_submit": "Match to Transaction",
  "___match-to-transaction_label_pagination-page-span": "",
  "match-to-transaction_text_no-transactions": "No records found.",
  "___match-to-transaction_text_refresh-data-error-message": "",
  "match-to-transaction_text_loading-message": "Matching to Transaction…",
  "match-to-transaction_error-no-claims-heading": "No Claim Records Found",
  "match-to-transaction_error-no-claims-message": "You must have a claim to attach this document to.",
  "match-to-transaction_label_posted-date": "Posted Date",
  "match-to-transaction_label_description": "Description",
  "match-to-transaction_label_transaction-type": "Transaction Type",
  "match-to-transaction_label_payment-amount": "Payment Amount",

  // SELECT DOCUMENT
  "select-document_page-title": "Select from My Records and Receipts",
  "___select-document_title_confirm-close": "",
  "___select-document_text_confirm-close": "",
  "___select-document_action_confirm-close_cancel": "",
  "___select-document_action_confirm-close_confirm": "",
  "___select-document_action_done": "",
  "select-document_label-file": "File",
  "select-document_action_attach": "Attach",
  "select-document_action_cancel": "Cancel",
  "select-document_error_no-documents-heading": "No Documents Found",
  "select-document-error_no-documents-message": "You must have documents in your evault to proceed."
};